<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('action.rentCalendar'), $t('text.list')]">
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <div
        v-for="(record, recordIndex) of records"
        :key="recordIndex"
        class="mgb20"
      >
        <div class="pd10" @click="showDFFun(recordIndex)">
          {{ record.date }}
          <span class="mgl20 float-right">
            <i class="el-icon-arrow-down" v-if="record.showDF"></i>
            <i class="el-icon-arrow-right" v-if="!record.showDF"></i>
          </span>
        </div>
        <div v-if="record.showDF">
          <vxe-table
            :data="record.rentsCompute"
            :merge-cells="record.mergeCells"
            id="bargainsTable"
            row-id="id"
            ref="recordsTable"
            class="recordsTable"
            :row-class-name="calculateBgColor"
            size="mini"
            resizable
            auto-resize
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column field="type" :title="$t('text.type')" width="94">
              <template v-slot="{ row }">
                <span v-if="!row.isMerge">
                  <div :class="'tag-type tag-type-' + row.type">
                    {{ $t("itemTypes." + row.type) }}
                  </div>
                </span>
                <div v-else>
                  <span v-if="row.type == 'rent'">
                    <span v-if="row.hurry">{{ $t("order.hurrySimple") }}</span>
                    <span class="a mgr5" @click="showRent(row)">
                      {{ row.serialNo }}
                    </span>
                    <span v-if="row.packageId != null" class="mgr5 strong">
                      {{ row.packageName }}
                    </span>
                    <span>
                      <span class="font10 mgr5">
                        {{ $t("text.total") }}:
                        {{ row.amount | currency }}
                      </span>
                      <span class="font10 mgr5">
                        {{ $t("payment.receive") }}:
                        {{ row.payAmount | currency }}
                      </span>
                      <template class="mgr5">
                        <span v-if="row.diffAmount > 0" class="red font10">
                          {{ $t("payment.differ") }}:
                          {{ row.diffAmount | currency }}
                        </span>
                        <span v-if="row.diffAmount == 0" class="green font10">
                          {{ $t("payment.settled") }}
                        </span>
                        <span v-if="row.diffAmount < 0" class="orange font10">
                          {{ $t("payment.leave") }}:{{
                            -row.diffAmount | currency
                          }}
                        </span>
                      </template>

                      <span
                        class="font10 mgr5 orange"
                        v-if="row.deposit != null"
                      >
                        {{ $t("rent.deposit") }}:
                        {{ row.depositAmount | currency }}
                        <span
                          v-if="row.depositReturnAmount != null"
                          class="green"
                        >
                          <!-- {{ $t("action.returnDeposit") }}:{{
                        row.depositReturnAmount | currency
                      }} -->
                          押金已退
                        </span>
                      </span>
                    </span>
                    <span class="float-right font10">
                      {{ $t("menu.customers") }}：{{ row.customerName }}&nbsp;
                      {{ $t("text.owner") }}:{{ row.ownerName }}
                      {{ row.shopName }}
                    </span>
                  </span>
                  <span v-if="row.type == 'clean'">
                    <span class="a mgr5" @click="showRent(row)">
                      {{ row.serialNo }}
                    </span>
                    <span class="font10 mgr5" v-if="row.serviceName != null">
                      {{ $t("rent.serviceName") }}:{{ row.serviceName }}
                    </span>
                    <span class="font10 mgr5" v-if="row.serviceAmount != null">
                      {{ $t("rent.serviceAmount") }}:{{
                        row.serviceAmount | currency
                      }}
                    </span>

                    <span class="float-right font10">
                      {{ $t("text.owner") }}:{{ row.ownerName }}
                      {{ row.shopName }}
                    </span>
                  </span>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="80"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="serialNo"
              :title="$t('rentItem.serialNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <span class="a" @click="showItem(row)">
                  {{ row.serialNo }}
                </span>
                <div v-if="row.workflowState">
                  <state-label
                    :state="row.workflowState"
                    v-if="['rent', 'clean', 'service'].includes(row.type)"
                  >
                    {{ $t("rentStates." + row.workflowState) }}
                  </state-label>
                  <state-label :state="row.workflowState" v-else>
                    {{ $t("orderStates." + row.workflowState) }}
                  </state-label>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.productNo }}
                <div class="font10">
                  {{ row.categoryName }}<span v-if="row.brand !== null">/</span
                  >{{ row.brand }}
                </div>
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="price"
              :title="$t('text.price2')"
              min-width="70"
            >
              <template v-slot="{ row }">
                <span
                  v-if="
                    row.type != 'clean' &&
                    row._rent &&
                    row._rent.packageId == null
                  "
                >
                  {{ row.price | currency }}
                </span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit || "" }}

                <template v-if="['custom', 'available'].includes(row.type)">
                  <el-popover
                    placement="right"
                    width="460"
                    trigger="click"
                    @show="getItemReceives(row)"
                  >
                    <vxe-table :data="itemReceives" size="mini">
                      <vxe-table-column
                        field="quantity"
                        :title="$t('text.quantity')"
                        min-width="50"
                      />
                      <vxe-table-column
                        field="ownerName"
                        :title="$t('order.receiveName')"
                        min-width="70"
                      />
                      <vxe-table-column
                        field="createAt"
                        :title="$t('order.receiveAt')"
                        width="180"
                      />
                      <vxe-table-column
                        field="remark"
                        :title="$t('text.remark')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <raw-html-limit-number
                            :content="row.remark"
                            :number="12"
                          />
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="voucher"
                        :title="$t('payment.voucher')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <thumbnail-text :srcs="row.voucher" />
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                    <div
                      slot="reference"
                      class="popover-reference font10"
                      v-if="row.receiveQuantity != 0"
                    >
                      {{ $t("action.receive") }}:{{ row.receiveQuantity
                      }}{{ row.unit || "" }}
                    </div>
                  </el-popover>
                  <el-popover
                    placement="right"
                    width="460"
                    trigger="click"
                    @show="getItemQualities(row)"
                  >
                    <vxe-table :data="itemQualities" size="mini">
                      <vxe-table-column
                        field="quantity"
                        :title="$t('text.quantity')"
                        min-width="50"
                      />
                      <vxe-table-column
                        field="ownerName"
                        :title="$t('order.quantityName')"
                        min-width="70"
                      />
                      <vxe-table-column
                        field="createAt"
                        :title="$t('order.quantityAt')"
                        width="180"
                      />
                      <vxe-table-column
                        field="remark"
                        :title="$t('text.remark')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <raw-html-limit-number
                            :content="row.remark"
                            :number="12"
                          />
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="voucher"
                        :title="$t('payment.voucher')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <thumbnail-text :srcs="row.voucher" />
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                    <div
                      slot="reference"
                      class="popover-reference font10"
                      v-if="row.qualityQuantity != 0"
                    >
                      {{ $t("action.quality") }}:{{ row.qualityQuantity
                      }}{{ row.unit || "" }}
                    </div>
                  </el-popover>
                  <el-popover
                    placement="right"
                    width="460"
                    trigger="click"
                    @show="getItemReworks(row)"
                  >
                    <vxe-table :data="itemReworks" size="mini">
                      <vxe-table-column
                        field="quantity"
                        :title="$t('text.quantity')"
                        min-width="50"
                      />
                      <vxe-table-column
                        field="ownerName"
                        :title="$t('order.reworkName')"
                        min-width="70"
                      />
                      <vxe-table-column
                        field="createAt"
                        :title="$t('order.reworkAt')"
                        width="180"
                      />
                      <vxe-table-column
                        field="remark"
                        :title="$t('text.remark')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <raw-html-limit-number
                            :content="row.remark"
                            :number="12"
                          />
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="voucher"
                        :title="$t('payment.voucher')"
                        min-width="80"
                      >
                        <template v-slot="{ row }">
                          <thumbnail-text :srcs="row.voucher" />
                        </template>
                      </vxe-table-column>
                    </vxe-table>

                    <div
                      slot="reference"
                      class="popover-reference font10"
                      v-if="row.reworkQuantity != 0"
                    >
                      {{ $t("action.rework") }}:{{ row.reworkQuantity
                      }}{{ row.unit || "" }}
                    </div>
                  </el-popover>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="endAt"
              :title="$t('rent.rentAtHandOverAt')"
              min-width="110"
            >
              <template v-slot="{ row }">
                <span v-if="['rent', 'clean', 'service'].includes(row.type)">
                  <div class="font10">{{ row.startAt }}</div>
                  <div class="font10">{{ row.endAt }}</div>
                </span>
                <span>{{ row.handOverAt }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="outName"
              :title="$t('rentItem.outName')"
              min-width="96"
            >
              <template v-slot="{ row }">
                {{ row.outName }}
                <div class="font10">{{ row.outAt }}</div>
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="finishName"
              :title="$t('rentItem.finishName')"
              min-width="96"
            >
              <template v-slot="{ row }">
                {{ row.finishName }}
                <div class="font10">{{ row.finishAt }}</div>
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="createAt"
              :title="$t('text.createAt')"
              min-width="110"
            />
            <vxe-table-column
              field="remark"
              :title="$t('text.remark')"
              min-width="80"
            >
              <template v-slot="{ row }">
                <raw-html-limit-number
                  :content="row.remark"
                  :number="10"
                  type="richText"
                />
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showRentDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show
        v-if="row && ['rent', 'service'].includes(row.type)"
        :id="currentRowRentId"
        @updateInfo="showRentUpdated"
      />
      <show-clean v-if="row && row.type == 'clean'" :id="currentRowRentId" />
    </drawer>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showItemDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-item-rent v-if="row && row.type == 'rent'" :id="currentRowItemId" />
      <show-item-service
        v-if="row && row.type == 'service'"
        :id="currentRowItemId"
      />
      <show-item-clean
        v-if="row && row.type == 'clean'"
        :id="currentRowItemId"
      />
    </drawer>
  </div>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Rent from "@/api/rent.js";
import Show from "@/views/rents/show";
import ShowItemRent from "@/views/rents/showItem";
import ShowItemService from "@/views/services/showItem";
import ShowItemClean from "@/views/cleans/showItem";

export default {
  mixins: [page],
  components: {
    Show,
    ShowItemRent,
    ShowItemService,
    ShowItemClean,
  },
  data() {
    return {
      loading: false,
      records: [],
      mergeCells: [],
      //
      row: null,
      currentRowIdx: null,
      currentRowRentId: null,
      currentRowItemId: null,

      showRentDF: false,
      showItemDF: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    showDFFun(index) {
      this.records[index].showDF = !this.records[index].showDF;
    },
    showRent(row) {
      this.row = row;
      this.currentRowRentId = row.id;
      this.showRentDF = true;
    },
    showRentUpdated() {
      this.loadData();
    },
    showItem(row) {
      this.row = row;
      this.currentRowItemId = row.id;
      this.showItemDF = true;
    },
    loadData() {
      const self = this;
      self.loading = true;
      Rent.newlyCalendar().then(function (res) {
        if (res.status == 200) {
          self.records = res.data;
          if (self.records.length != 0) {
            for (let record of self.records) {
              const rentsCompute = self.buildTableData(record.rents);
              Vue.set(record, "rentsCompute", rentsCompute);
              Vue.set(record, "mergeCells", self.buildMergeCells(rentsCompute));
            }
          }
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },
    //
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bRent = {
          isMerge: true,
          id: record.id,
          serialNo: record.serialNo,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          remark: record.remark,
          cancelAt: record.cancelAt,
          cancelReason: record.cancelReason,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          shopId: record.shopId,
          shopName: record.shopName,
          createAt: record.createAt,
          tenantId: record.tenantId,
          startAt: record.startAt,
          endAt: record.endAt,
          customerSource: record.customerSource,
          amount: record.amount,
          payAmount: record.payAmount,
          diffAmount: record.diffAmount,
          items: record.items,
          payments: record.payments,
          type: record.type,
          packageId: record.packageId,
          packageName: record.packageName,
          packageAmount: record.packageAmount,
          scheduleId: record.scheduleId,
          deposit: record.deposit,
          depositAmount: record.depositAmount,
          depositReturnAmount: record.depositReturnAmount,
          serviceName: record.serviceName,
          serviceAmount: record.serviceAmount,
          items: record.items,
        };
        rs.push(bRent); //将bargain的数据转换到格式，放到数据列表

        record.items.forEach((item) => {
          Vue.set(item, "_rent", record);
          rs.push(item);
        });
      });
      return rs;
    },
    buildMergeCells(rentsCompute) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < rentsCompute.length; i++) {
        if (rentsCompute[i].isMerge) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 11 });
        }
        if (rentsCompute[i].items) {
          rowIdx = rowIdx + rentsCompute[i].items.length + 1;
        }
      }
      return mcs;
    },

    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },

    mergeMethod(data, { rowIndex, columnIndex }) {
      console.log("===", data);
      // const mergeCells = this.mergeCells;
      // for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
      //   const { row, col, rowspan, colspan } = mergeCells[mIndex];
      //   if (row === rowIndex && col === columnIndex) {
      //     return { rowspan, colspan };
      //   }
      //   if (
      //     rowIndex >= row &&
      //     rowIndex < row + rowspan &&
      //     columnIndex >= col &&
      //     columnIndex < col + colspan
      //   ) {
      //     return { rowspan: 0, colspan: 0 };
      //   }
      // }
      // return { rowspan: 1, colspan: 1 };
      return {};
    },

    cellStyle({ row, rowIndex, column, columnIndex }) {
      if (columnIndex == 0) {
        return {
          "vertical-align": "top",
        };
      }
      return "";
    },
  },
};
</script>
<style scoped>
</style>